<template>
  <div>
    <el-row class="search"
      ><span>类型：</span
      ><el-select filterable v-model="search.type" placeholder="">
        <el-option
          v-for="(item, itemIndex) in typelist"
          v-bind:key="itemIndex + 99"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
      <span>场景：</span
      ><el-select filterable v-model="search.scene" placeholder="">
        <el-option
          v-for="(item, itemIndex) in scenelist"
          v-bind:key="itemIndex + 99"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
      <span>状态：</span
      ><el-select filterable v-model="search.valid" placeholder="">
        <el-option
          v-for="(item, itemIndex) in statuslist"
          v-bind:key="itemIndex + 99"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
      <span>isNew标签：</span
      ><el-select filterable v-model="search.isNew" placeholder="">
        <el-option
          v-for="(item, itemIndex) in isNews"
          v-bind:key="itemIndex + 99"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
      <span>活动名称:</span
      ><el-input v-model="search.desc" style="width: 230px"></el-input>
      <el-button type="primary" @click="query(1)" :loading="loading">
        查询
      </el-button>
      <el-button type="warning" @click="operate(1)"> 新增 </el-button></el-row
    >
    <el-row>
      <el-table
        :data="datalist"
        style="width: 100%"
        v-loading="loading"
        height="60vh"
        stripe
        border
      >
        <el-table-column label="类型">
          <template slot-scope="scope">
            {{
              typelist.filter((x) => x.value == scope.row.type)[0] &&
              typelist.filter((x) => x.value == scope.row.type)[0].name
            }}
          </template>
        </el-table-column>
        <el-table-column prop="url" label="访问链接"> </el-table-column>
        <el-table-column prop="icon" label="图标链接地址">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: auto"
              :src="scope.row.icon"
              :preview-src-list="[scope.row.icon]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="desc" label="名字"> </el-table-column>
        <el-table-column prop="scene" label="场景">
          <template slot-scope="scope">
            {{
              scenelist.filter((x) => x.value == scope.row.scene)[0] &&
              scenelist.filter((x) => x.value == scope.row.scene)[0].name
            }}
          </template>
        </el-table-column>
        <el-table-column label="用户群体">
          <template slot-scope="scope">
            {{
              userGroupList.filter((x) => x.value == scope.row.userGroup)[0] &&
              userGroupList.filter((x) => x.value == scope.row.userGroup)[0].name
            }}
          </template>
        </el-table-column>
        <el-table-column label="渠道列表" width="120">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="showChannelDialog(scope.row.channelSet)"
              v-if="scope.row.channelSet && scope.row.channelSet.length > 0"
            >
              查看({{ scope.row.channelSet.length }})
            </el-button>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column label="国家列表" width="120">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="showCountryDialog(scope.row.countryCodeSet)"
              v-if="scope.row.countryCodeSet && scope.row.countryCodeSet.length > 0"
            >
              查看({{ scope.row.countryCodeSet.length }})
            </el-button>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderNum" label="排序值"> </el-table-column>
        <el-table-column prop="valid" label="状态">
          <template slot-scope="scope">
            <el-button
              type="primary"
              @click="updownStatus(1, scope.row.id)"
              v-if="scope.row.valid == 0"
              size="mini"
            >
              上架
            </el-button>
            <el-button
              type="danger"
              @click="updownStatus(0, scope.row.id)"
              v-if="scope.row.valid == 1"
              size="mini"
            >
              下架
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="ctime" label="创建时间"> </el-table-column>
        <el-table-column prop="mtime" label="修改时间"> </el-table-column>
        <el-table-column prop="configKey" label="配置key"> </el-table-column>
        <el-table-column label="hot标签">
          <template slot-scope="scope">
            {{ scope.row.hot == 1 ? '是' : '不是' }}
          </template>
        </el-table-column>
        <el-table-column label="isNew标签">
          <template slot-scope="scope">
            {{ scope.row.isNew == 1 ? '有' : '没有' }}
          </template>
        </el-table-column>
        <el-table-column prop="upTime" label="上架时间"> </el-table-column>
        <el-table-column prop="downTime" label="下架时间"> </el-table-column>
        <el-table-column prop="operator" label="操作人"> </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="operate(2, scope.row)"
              >编辑</el-button
            >
          </template></el-table-column
        >
      </el-table>
    </el-row>
    <el-row>
      <el-pagination
        :current-page.sync="pageInfo.page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="pageInfo.total"
        class="pagination"
        :page-size="30"
      ></el-pagination>
    </el-row>
    <el-drawer
      :title="type === 2 ? '编辑' : '新增'"
      size="40%"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <div class="item">
        <span>类型：</span
        ><el-select filterable v-model="data.type" placeholder="">
          <el-option
            v-for="(item, itemIndex) in typelist.slice(1)"
            v-bind:key="itemIndex + 99"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="item">
        <span>访问链接：</span><el-input type="text" v-model="data.url" />
      </div>
      <div class="item">
        <span>图片：</span
        ><el-upload
          class="avatar-uploader"
          action=""
          :auto-upload="false"
          :show-file-list="false"
          :on-change="changfile"
          ref="upload"
        >
          <el-image
            v-if="data.icon !== ''"
            style="width: auto; height: 178px"
            :src="data.icon"
            fit="scale-down"
          ></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="item">
        <span>名字：</span><el-input type="text" v-model="data.desc" />
      </div>
      <div class="item">
        <span>场景：</span
        ><el-select filterable v-model="data.scene" placeholder="">
          <el-option
            v-for="(item, itemIndex) in scenelist.slice(1)"
            v-bind:key="itemIndex + 99"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="item">
        <span>用户群体：</span
        ><el-select filterable v-model="data.userGroup" placeholder="请选择" style="width: 200px">
          <el-option
            v-for="(item, itemIndex) in userGroupList"
            v-bind:key="itemIndex + 99"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="item">
        <span>渠道列表：</span
        ><el-select
          filterable
          multiple
          collapse-tags
          v-model="data.channelSet"
          placeholder="请选择渠道"
          style="width: 300px"
        >
          <el-option
            v-for="item in channelList"
            :key="item.channelId"
            :label="item.name"
            :value="item.value || item.channelId"
          >
          </el-option>
        </el-select>
      </div>
      <div class="item">
        <span>国家码列表：</span
        ><el-select
          filterable
          multiple
          collapse-tags
          v-model="data.countryCodeSet"
          placeholder="请选择国家"
          style="width: 300px"
        >
          <el-option
            v-for="item in countryList"
            :key="item.countryCode"
            :label="item.country"
            :value="item.countryCode"
          >
          </el-option>
        </el-select>
      </div>
      <div class="item" v-if="data.userGroup == 6">
        <span>指定用户ID：</span
        ><el-input
          type="textarea"
          v-model="data.ridSet"
          placeholder="请输入用户ID，多个ID用逗号分隔"
          :rows="3"
          style="width: 300px"
        />
      </div>
      <div class="item">
        <span>排序值：</span><el-input type="number" v-model="data.orderNum" />
      </div>
      <div class="item">
        <span>状态：</span
        ><el-switch
          v-model="data.valid"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="上架"
          inactive-text="下架"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </div>
      <div class="item">
        <span>配置key：</span><el-input type="text" v-model="data.configKey" />
      </div>
      <div class="item">
        <span>上下架时间：</span
        ><el-date-picker
          v-model="data.updownDate"
          type="datetimerange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </div>
      <div class="item">
        <span>hot标签：</span
        ><el-switch
          v-model="data.hot"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="是"
          inactive-text="不是"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </div>
      <div class="item">
        <span>isNews标签:</span
        ><el-switch
          v-model="data.isNew"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="有"
          inactive-text="没有"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </div>
      <div class="item">
        <span>排除策略用户群体：</span
        ><el-select
          filterable
          multiple
          collapse-tags
          v-model="data.strategyUserGroupList"
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in userGroup"
            v-bind:key="itemIndex + 99"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="item">
        <el-button type="primary" @click="operate(3)" v-if="type == 1"
          >新增</el-button
        >
        <el-button type="primary" @click="operate(4)" v-if="type == 2"
          >编辑</el-button
        >
      </div>
    </el-drawer>
    <!-- 渠道列表弹窗 -->
    <el-dialog title="渠道列表" :visible.sync="channelDialogVisible" width="500px">
      <div v-if="currentChannelList && currentChannelList.length > 0">
        <el-tag
          v-for="(channel, index) in currentChannelList"
          :key="index"
          style="margin: 5px"
        >
          {{ getChannelName(channel) }}
        </el-tag>
      </div>
      <div v-else>无数据</div>
    </el-dialog>
    <!-- 国家列表弹窗 -->
    <el-dialog title="国家列表" :visible.sync="countryDialogVisible" width="500px">
      <div v-if="currentCountryList && currentCountryList.length > 0">
        <el-tag
          v-for="(country, index) in currentCountryList"
          :key="index"
          style="margin: 5px"
        >
          {{ getCountryName(country) }}
        </el-tag>
      </div>
      <div v-else>无数据</div>
    </el-dialog>
  </div>
</template>
<script>
import { timestampToTime } from '@/utils/common'
import { getConstList } from '@/api/constRequest'
export default {
  data() {
    return {
      typelist: [],
      scenelist: [],
      statuslist: [
        { name: '上架', value: 1 },
        { name: '下架', value: 0 },
      ],
      userGroup: [],
      userGroupList: [],
      channelList: [],
      countryList: [],
      // 弹窗相关
      channelDialogVisible: false,
      countryDialogVisible: false,
      currentChannelList: [],
      currentCountryList: [],
      datalist: [],
      loading: false,
      drawer: false,
      type: 1,
      search: {
        type: 0,
        scene: 0,
        valid: 1,
        desc: '',
        isNew: 0,
      },
      pageInfo: {
        page: 1,
        total: 0,
      },
      isNews: [
        { name: '有', value: 1 },
        { name: '没有', value: 0 },
      ],
      data: {
        id: '',
        type: '',
        url: '',
        icon: '',
        desc: '',
        scene: '',
        orderNum: '',
        valid: 0,
        configKey: '',
        updownDate: [],
        userGroup: 0,
        channelSet: [],
        countryCodeSet: [],
        ridSet: '',
        hot: 0,
        isNew: 0,
        strategyUserGroupList: [],
        operator: this.$store.getters.username,
      },
    }
  },
  methods: {
    async typeQuery() {
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.generate_type_query,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      this.typelist = res.data
      this.typelist.unshift({ name: 'all', value: 0 })
    },
    async getGroup() {
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.generate_getGroup,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      if (res.code != 0) return this.$message.error(res.msg)
      this.userGroup = [{ name: 'ALL', value: '' }, ...res.data]
    },
    async getUserGroupList() {
      const res = await getConstList('userGroup')
      if (res.code != 0) return this.$message.error(res.msg)
      this.userGroupList = res.data || []
    },
    async getChannel() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.newChannelList +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })
      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.channelList = res.data
      }
    },
    async getCountryCode() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.normal_country +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })
      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.countryList = (res.data.countryList || []).filter(
          item => item.countryCode !== 'all' && item.countryCode !== 'total'
        )
      }
    },
    async sceneQuery() {
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.generate_scene_query,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      this.scenelist = res.data
      this.scenelist.unshift({ name: 'all', value: 0 })
    },
    async query(page) {
      this.loading = true
      let url =
        this.$store.getters.path.generate_query +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      if (page) this.pageInfo.page = 1
      let data = {
        type: this.search.type,
        scene: this.search.scene,
        valid: this.search.valid,
        page: this.pageInfo.page,
        desc: this.search.desc,
      }
      const { data: res } = await this.$axios.post(url, data)
      this.loading = false
      if (res.code != 0) return this.$message.error(res.msg)
      console.log(res.data.data)
      console.log(res.data.data)
      this.datalist = res.data.data
      this.pageInfo.total = res.data.total
      this.datalist.map((item) => {
        if (item.ctime !== 0) item.ctime = timestampToTime(item.ctime)
        if (item.mtime !== 0) item.mtime = timestampToTime(item.mtime)
        if (item.upTime !== 0) item.upTime = timestampToTime(item.upTime)
        if (item.downTime !== 0) item.downTime = timestampToTime(item.downTime)
      })
      this.$message.success('查询成功')
    },
    async updownStatus(type, id) {
      this.$confirm(type == 0 ? '确认下架' : '确认上架', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const { data: res } = await this.$axios(
            this.$store.getters.path.generate_upp +
              '?username=' +
              this.$store.getters.username +
              '&token=' +
              this.$store.getters.token +
              '&id=' +
              id +
              '&valid=' +
              type,
            {}
          )
          if (res.code !== 0) return this.$message.error('操作失败')
          this.$message.success('操作成功')
          this.query()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          })
        })
    },
    handleCurrentChange(num) {
      this.pageInfo.page = num
      this.query()
    },
    async operate(type, obj) {
      if (type == 1) {
        this.type = type
        this.drawer = true
      } else if (type == 2) {
        this.type = type
        this.drawer = true
        this.data = {
          id: obj.id,
          type: obj.type,
          url: obj.url,
          icon: obj.icon,
          desc: obj.desc,
          scene: obj.scene,
          orderNum: obj.orderNum,
          valid: obj.valid,
          configKey: obj.configKey,
          hot: obj.hot,
          isNew: obj.isNew,
          updownDate: [],
          userGroup: obj.userGroup || 0,
          channelSet: obj.channelSet || [],
          countryCodeSet: obj.countryCodeSet || [],
          ridSet: obj.ridSet ? (Array.isArray(obj.ridSet) ? obj.ridSet.join(',') : obj.ridSet) : '',
          operator: this.$store.getters.username,
          strategyUserGroupList: obj.strategyUserGroupList || [],
        }
        if (obj.upTime !== 0) {
          this.data.updownDate[0] = obj.upTime
          this.data.updownDate[1] = obj.downTime
        }
      } else if (type == 3) {
        // 处理 ridSet：只有当 userGroup == 6 时才处理，否则为空数组
        let ridSetArray = []
        if (this.data.userGroup == 6 && this.data.ridSet) {
          if (typeof this.data.ridSet === 'string') {
            ridSetArray = this.data.ridSet.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id))
          } else if (Array.isArray(this.data.ridSet)) {
            ridSetArray = this.data.ridSet
          }
        }
        const { data: res } = await this.$axios.post(
          this.$store.getters.path.generate_add +
            '?username=' +
            this.$store.getters.username +
            '&token=' +
            this.$store.getters.token,
          {
            ...this.data,
            ridSet: ridSetArray,
            upTime: this.data.updownDate[0] ? Date.parse(new Date(this.data.updownDate[0])) / 1000 : 0,
            downTime: this.data.updownDate[1] ? Date.parse(new Date(this.data.updownDate[1])) / 1000 : 0,
          }
        )
        if (res.code != 0) return this.$message(res.msg)
        this.$message.success('操作成功')
        this.query()
        this.handleClose()
      } else if (type == 4) {
        // 处理 ridSet：只有当 userGroup == 6 时才处理，否则为空数组
        let ridSetArray = []
        if (this.data.userGroup == 6 && this.data.ridSet) {
          if (typeof this.data.ridSet === 'string') {
            ridSetArray = this.data.ridSet.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id))
          } else if (Array.isArray(this.data.ridSet)) {
            ridSetArray = this.data.ridSet
          }
        }
        const { data: res } = await this.$axios.post(
          this.$store.getters.path.generate_edit +
            '?username=' +
            this.$store.getters.username +
            '&token=' +
            this.$store.getters.token,
          {
            ...this.data,
            ridSet: ridSetArray,
            upTime: this.data.updownDate[0] ? Date.parse(new Date(this.data.updownDate[0])) / 1000 : 0,
            downTime: this.data.updownDate[1] ? Date.parse(new Date(this.data.updownDate[1])) / 1000 : 0,
          }
        )
        if (res.code != 0) return this.$message(res.msg)
        this.$message.success('操作成功')
        this.query()
        this.handleClose()
      }
    },
    async changfile(file) {
      this.dwnload = true
      const formdata = new FormData()
      formdata.append('file', file.raw)
      formdata.append('cover', 0)
      formdata.append('dir', 'banner/user/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        formdata
      )
      this.dwnload = false
      if (res.code !== 0) {
        this.$refs.upload.clearFiles()
        return this.$message.error('文件上传失败请重新选择文件上传')
      }
      this.data.icon = res.data
    },
    // 显示渠道列表弹窗
    showChannelDialog(channelSet) {
      this.currentChannelList = channelSet || []
      this.channelDialogVisible = true
    },
    // 显示国家列表弹窗
    showCountryDialog(countryCodeSet) {
      this.currentCountryList = countryCodeSet || []
      this.countryDialogVisible = true
    },
    // 获取渠道名称
    getChannelName(channelValue) {
      const channel = this.channelList.find(item => (item.value || item.channelId) == channelValue)
      return channel ? channel.name : channelValue
    },
    // 获取国家名称
    getCountryName(countryCode) {
      const country = this.countryList.find(item => item.countryCode == countryCode)
      return country ? country.country : countryCode
    },
    handleClose() {
      this.drawer = false
      this.data = {
        id: '',
        type: '',
        url: '',
        icon: '',
        desc: '',
        scene: '',
        orderNum: '',
        valid: 0,
        configKey: '',
        updownDate: [],
        userGroup: 0,
        channelSet: [],
        countryCodeSet: [],
        ridSet: '',
        hot: 0,
        isNew: 0,
        strategyUserGroupList: [],
        operator: this.$store.getters.username,
      }
    },
  },
  watch: {
    'data.userGroup'(newVal) {
      // 当 userGroup 改变且不等于 6 时，清空 ridSet
      if (newVal != 6) {
        this.data.ridSet = ''
      }
    },
  },
  created() {
    this.typeQuery()
    this.sceneQuery()
    this.query()
    this.getGroup()
    this.getUserGroupList()
    this.getChannel()
    this.getCountryCode()
  },
}
</script>
<style lang="scss" scoped>
.search {
  display: flex;
  align-items: center;

  .el-input {
    max-width: 250px;
  }

  > * {
    margin: 0 3px;
  }
}

.item {
  display: flex;
  align-items: center;
  padding: 5px 15px;

  span {
    white-space: nowrap;
    padding: 0 5px;
  }
}
</style>
